function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import FormMixin from '../form.mixin';

var SpecificQuestions = /*#__PURE__*/function () {
  function SpecificQuestions() {
    _classCallCheck(this, SpecificQuestions);
  }

  _createClass(SpecificQuestions, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-specific-questions', {
        template: "\n        <div v-if=\"specificQuestions\">\n          <div class=\"specific-questions-wrapper\" :class=\"bind.class\">\n            <div class=\"cell medium-12\" v-for=\"(item, index) in specificQuestions\" :key=\"item.value\">\n              <span class=\"specific-question\" v-if=\"conditionsMet(item)\">\n                <h5 class=\"specific-question--label\" :class=\"questionIsFreeText(item) ? 'collapse-margin' : ''\">{{ item.questionText }}*</h5>\n                <roche-checkbox-group v-if=\"item.multipleAnswers === 'Y'\" :rules=\"[$root.rules.required]\" v-model=\"values[item.questionText]\" :items=\"item.answers\" @input=\"updated\"></roche-checkbox-group>\n                <roche-textarea v-else-if=\"questionIsFreeText(item)\" :rules=\"[$root.rules.required]\" v-model=\"values[item.questionText]\" @change=\"updated\"></roche-textarea>\n                <roche-radio-group v-else :rules=\"[$root.rules.required]\" v-model=\"values[item.questionText]\" :items=\"item.answers\" @change=\"updated\"></roche-radio-group>\n              </span>\n            </div>\n          </div>\n        </div>\n      ",
        mixins: [FormMixin],
        props: {
          dosageForm: {
            type: Object,
            "default": function _default() {}
          },
          isSusvimoFlow: {
            type: Boolean,
            "default": false
          }
        },
        data: function data() {
          return {
            values: {}
          };
        },
        computed: {
          specificQuestions: function specificQuestions() {
            var _this = this;

            if (!this.$store.getters['forms/fullDosageFormSpecificQuestions']) {
              return null;
            }

            if (this.isSusvimoFlow) {
              var activeHandlingSteps = this.$store.getters['forms/susvimoLevel4Images'].filter(function (step) {
                return _this.$store.state.forms.form.handlingSteps.includes(step.imageLabel);
              });
              var specificQuestions = [];
              activeHandlingSteps.forEach(function (step) {
                specificQuestions.push.apply(specificQuestions, _toConsumableArray(step.questionsAnswers));
              });
              var deduped = uniqBy(specificQuestions, 'questionId');
              return sortBy(deduped, 'displayOrder');
            }

            return this.$store.getters['forms/fullDosageFormSpecificQuestions'];
          },
          specificQuestionsValue: function specificQuestionsValue() {
            if (Object.keys(this.values).length !== 0) {
              return JSON.stringify(this.values);
            }

            return null;
          }
        },
        methods: {
          updated: function updated() {
            var _this2 = this;

            this.specificQuestions.forEach(function (question) {
              if (_this2.values[question.value] && !_this2.conditionsMet(question)) {
                delete _this2.values[question.value];
              }
            });
            this.$emit('input', this.specificQuestionsValue);
          },
          conditionsMet: function conditionsMet(question) {
            if (!question.condition) return true;
            if (this.values[question.condition.conditionQuestion] === question.condition.conditionValue) return true;
            return false;
          },
          questionIsFreeText: function questionIsFreeText(question) {
            return question.answers.length === 1 && question.answers[0].value === 'Free text';
          }
        }
      });
    }
  }]);

  return SpecificQuestions;
}();

export default SpecificQuestions;